import React, { Component } from 'react'
import { connect } from 'react-redux'
import { navigateTo } from '../../helpers/navigationHelpers'

import Notifications from '../../components/Notifications';
import SignInForm from '../../components/sessions/SignInForm'

class SessionNew extends Component {
  constructor(props) {
    super(props)

    this.navigateTo = navigateTo.bind(this);
  }

  onFormSubmit = (formData) => {
    this.props.dispatch({
      type: 'SIGN_IN_SAGA',
      payload: { formData: formData },
      callback: this.afterFormSubmit
    })
  }

  afterFormSubmit = (status, data) => {
    status === 'success' ? this.onFormSubmitSuccess(data) : this.onFormSubmitFailure(data)
  }

  onFormSubmitSuccess = (data) => {
    this.navigateTo('dashboard')
  }

  onFormSubmitFailure = (data) => {
    this.props.dispatch(Notifications.error({ message: data.alertMessage }))
  }

  render() {
    return (
      <div className={'no-session-content'}>
        <SignInForm onSubmit={this.onFormSubmit} />
      </div>
    )
  }
} // class SessionNew

export default connect(() => ({}))(SessionNew)
